import React from 'react';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, error, className = '', onCheckedChange, onChange, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        <label className={`inline-flex items-center cursor-pointer ${className}`}>
          <div className="relative flex items-center">
            <input
              type="checkbox"
              ref={ref}
              className="peer sr-only"
              onChange={(event) => {
                onChange?.(event);
                onCheckedChange?.(event.target.checked);
              }}
              {...props}
            />
            <div className="h-5 w-5 rounded border-2 border-slate-300 bg-white transition-all peer-checked:border-brand-600 peer-checked:bg-brand-600 peer-focus:ring-2 peer-focus:ring-brand-600/20" />
            <i className="ri-check-line absolute inset-0 flex items-center justify-center text-white opacity-0 transition-opacity peer-checked:opacity-100" />
          </div>
          {label && <span className="ml-3 text-sm font-medium text-slate-700">{label}</span>}
        </label>
        {error && <p className="text-xs text-red-500 mt-1 ml-8">{error}</p>}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
